import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import Footer from "./components/Footer";
import PrivateRoute from "./components/PrivateRoute";

import Login from "./pages/Login";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import Classes from "./pages/Classes";
import ArchivedClasses from "./pages/ArchivedClasses";
import DeletedClasses from "./pages/DeletedClasses";
import Profile from "./pages/Profile";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import CycleManagement from "./pages/CycleManagement";
import StateManagement from "./pages/StateManagement";
import UserLicenses from "./pages/UserLicenses";
import ProfessionManagement from "./pages/ProfessionManagement";
import { useAuth } from './useAuth';
import { trackStatcounterPageview } from './utils/analytics';
import AdminPanel from './pages/AdminPanel';
import AdminDashboard from './pages/AdminDashboard';
import AdminUserEdit from './pages/AdminUserEdit';
import AdminUserView from './pages/AdminUserView';
import AdminUserAdd from './pages/AdminUserAdd';
import UserComplianceReport from './pages/UserComplianceReport';
import BulkImport from './pages/BulkImport';
import CreateClass from './pages/CreateClass';
import AdminClassBrowser from './pages/AdminClassBrowser';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Contact from './pages/Contact';
import HowItWorks from './pages/HowItWorks';
import CreditDistributionGuide from './pages/CreditDistributionGuide';
import AIPageDesignManagement from './pages/AIPageDesignManagement';
import MarketingEmailAdmin from './pages/MarketingEmailAdmin';
import LinkedInAdmin from './pages/LinkedInAdmin';
import AdminOnboarding from './pages/AdminOnboarding';
import AdminAITools from './pages/AdminAITools';
import AdminCEAudit from './pages/AdminCEAudit';
import AdminCertificates from './pages/AdminCertificates';
import AdminSettings from './pages/AdminSettings';
import NotFound from './pages/NotFound';
import CETrackingGuide from './pages/CETrackingGuide';
import Pricing from './pages/Pricing';
import BillingSettings from './pages/BillingSettings';
import TeamDashboard from './pages/TeamDashboard';
import FirmSession from './pages/FirmSession';
import TeamMemberManage from './pages/TeamMemberManage';
import TeamHelpGuide from './pages/TeamHelpGuide';
import TeamComplianceReport from './pages/TeamComplianceReport';
import InviteAccept from './pages/InviteAccept';
import UnsubscribePage from './pages/UnsubscribePage';
import EmailPreferencesUnsubscribe from './pages/EmailPreferencesUnsubscribe';
import PlanIntentBanner from './components/PlanIntentBanner';
import TrialBanner from './components/TrialBanner';
import ImpersonationBanner from './components/ImpersonationBanner';
import LandingModern from './pages/pagedesign/LandingModern';
import LandingTest10 from './pages/pagedesign/LandingTest10';
import LandingMinimalist from './pages/pagedesign/LandingMinimalist';
import LandingOriginal from './pages/pagedesign/LandingOriginal';
import LandingTailwind from './pages/LandingTailwind';
import NYLicenseRenewal from './pages/NYLicenseRenewal';
import CTLicenseRenewal from './pages/CTLicenseRenewal';
import NJLicenseRenewal from './pages/NJLicenseRenewal';
import CALicenseRenewal from './pages/CALicenseRenewal';
import WALicenseRenewal from './pages/WALicenseRenewal';
import ILLicenseRenewal from './pages/ILLicenseRenewal';
import GALicenseRenewal from './pages/GALicenseRenewal';
import FLLicenseRenewal from './pages/FLLicenseRenewal';
import MALicenseRenewal from './pages/MALicenseRenewal';
import PALicenseRenewal from './pages/PALicenseRenewal';
import TXLicenseRenewal from './pages/TXLicenseRenewal';
import INLicenseRenewal from './pages/INLicenseRenewal';
import MOLicenseRenewal from './pages/MOLicenseRenewal';
import WILicenseRenewal from './pages/WILicenseRenewal';
import SCLicenseRenewal from './pages/SCLicenseRenewal';
import KYLicenseRenewal from './pages/KYLicenseRenewal';
import ALLicenseRenewal from './pages/ALLicenseRenewal';
import UTLicenseRenewal from './pages/UTLicenseRenewal';
import NVLicenseRenewal from './pages/NVLicenseRenewal';
import OKLicenseRenewal from './pages/OKLicenseRenewal';
import ARLicenseRenewal from './pages/ARLicenseRenewal';
import AKLicenseRenewal from './pages/AKLicenseRenewal';
import AZLicenseRenewal from './pages/AZLicenseRenewal';
import COLicenseRenewal from './pages/COLicenseRenewal';
import DCLicenseRenewal from './pages/DCLicenseRenewal';
import DELicenseRenewal from './pages/DELicenseRenewal';
import HILicenseRenewal from './pages/HILicenseRenewal';
import IALicenseRenewal from './pages/IALicenseRenewal';
import IDLicenseRenewal from './pages/IDLicenseRenewal';
import KSLicenseRenewal from './pages/KSLicenseRenewal';
import LALicenseRenewal from './pages/LALicenseRenewal';
import MDLicenseRenewal from './pages/MDLicenseRenewal';
import MELicenseRenewal from './pages/MELicenseRenewal';
import MILicenseRenewal from './pages/MILicenseRenewal';
import MNLicenseRenewal from './pages/MNLicenseRenewal';
import MSLicenseRenewal from './pages/MSLicenseRenewal';
import MTLicenseRenewal from './pages/MTLicenseRenewal';
import NCLicenseRenewal from './pages/NCLicenseRenewal';
import NDLicenseRenewal from './pages/NDLicenseRenewal';
import NELicenseRenewal from './pages/NELicenseRenewal';
import NHLicenseRenewal from './pages/NHLicenseRenewal';
import NMLicenseRenewal from './pages/NMLicenseRenewal';
import OHLicenseRenewal from './pages/OHLicenseRenewal';
import ORLicenseRenewal from './pages/ORLicenseRenewal';
import RILicenseRenewal from './pages/RILicenseRenewal';
import SDLicenseRenewal from './pages/SDLicenseRenewal';
import TNLicenseRenewal from './pages/TNLicenseRenewal';
import VALicenseRenewal from './pages/VALicenseRenewal';
import VTLicenseRenewal from './pages/VTLicenseRenewal';
import WVLicenseRenewal from './pages/WVLicenseRenewal';
import WYLicenseRenewal from './pages/WYLicenseRenewal';
import StateRequirementInfo from './pages/StateRequirementInfo';
import StateLanding from './pages/StateLanding';
import ProfessionLanding from './pages/ProfessionLanding';
// App routes configured below; ensure all page components exist and compile

const CycleDetail = React.lazy(() => import("./pages/CycleDetail"));
const EditClass = React.lazy(() => import("./pages/EditClass"));

// App-interior pages (authenticated) need bottom padding; public/marketing pages do not
const APP_PAGE_PREFIXES = ['/dashboard', '/classes', '/cycles', '/my-licenses', '/profile', '/billing', '/admin', '/team', '/add-class', '/edit-class'];

function useNeedsBottomPadding() {
  const { pathname } = useLocation();
  return APP_PAGE_PREFIXES.some(prefix => pathname === prefix || pathname.startsWith(prefix + '/'));
}

function useStatcounterPageviews() {
  const { pathname } = useLocation();
  const isFirstRender = React.useRef(true);
  React.useEffect(() => {
    // The static script tag in index.html already covers the initial load —
    // only re-fire on subsequent client-side route changes, which Statcounter's
    // counter.js otherwise never sees (see analytics.ts for why).
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    trackStatcounterPageview();
  }, [pathname]);
}

function AppInner({ user, logout }: { user: any; logout: () => void }) {
  const needsBottomPadding = useNeedsBottomPadding();
  useStatcounterPageviews();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <ImpersonationBanner />
      <Navbar user={user} logout={logout} />
      <TrialBanner />
      <PlanIntentBanner />
      <div style={{ display: 'flex', flex: '1', minHeight: 0 }}>
        {user && <Sidebar user={user} />}
        <div style={{ flex: '1', minWidth: 0, paddingBottom: needsBottomPadding ? '3rem' : 0 }}>
          <React.Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/ce-tracking-software" element={<CETrackingGuide />} />
              <Route path="/how-it-works/credit-distribution" element={<CreditDistributionGuide />} />
              <Route path="/states/:stateSlug" element={<StateLanding />} />
              <Route path="/profession/:professionSlug" element={<ProfessionLanding />} />
              <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/classes" element={<PrivateRoute><Classes /></PrivateRoute>} />
              <Route path="/archived-classes" element={<PrivateRoute><ArchivedClasses /></PrivateRoute>} />
              <Route path="/deleted-classes" element={<PrivateRoute><DeletedClasses /></PrivateRoute>} />
              <Route path="/classes/import" element={<PrivateRoute><BulkImport /></PrivateRoute>} />
              <Route path="/classes/:id" element={<PrivateRoute><EditClass /></PrivateRoute>} />
              <Route path="/add-class" element={<PrivateRoute><CreateClass /></PrivateRoute>} />
              <Route path="/cycles" element={<PrivateRoute><CycleManagement /></PrivateRoute>} />
              <Route path="/cycles/:id" element={<PrivateRoute><CycleDetail /></PrivateRoute>} />
              <Route path="/states" element={<PrivateRoute>{user && user.role === 'admin' ? <StateManagement /> : <div>Access denied</div>}</PrivateRoute>} />
              <Route path="/my-licenses" element={<PrivateRoute><UserLicenses /></PrivateRoute>} />
              <Route path="/requirements/:professionID/:stateID" element={<PrivateRoute><StateRequirementInfo /></PrivateRoute>} />
              <Route path="/admin/professions" element={<PrivateRoute><ProfessionManagement /></PrivateRoute>} />
              <Route path="/professions" element={<PrivateRoute><ProfessionManagement /></PrivateRoute>} />
              <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
              <Route path="/admin" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
              <Route path="/admin/panel" element={<PrivateRoute><AdminPanel /></PrivateRoute>} />
              <Route path="/admin/users/:id/view" element={<PrivateRoute><AdminUserView /></PrivateRoute>} />
              <Route path="/admin/users/:id" element={<PrivateRoute><AdminUserEdit /></PrivateRoute>} />
              <Route path="/admin/users/add" element={<PrivateRoute><AdminUserAdd /></PrivateRoute>} />
              <Route path="/admin/compliance-report/:userId" element={<PrivateRoute><UserComplianceReport /></PrivateRoute>} />
              <Route path="/admin/class-browser" element={<PrivateRoute><AdminClassBrowser /></PrivateRoute>} />
              <Route path="/admin/ai-page-designs" element={<PrivateRoute><AIPageDesignManagement /></PrivateRoute>} />
              <Route path="/admin/marketing-email" element={<PrivateRoute><MarketingEmailAdmin /></PrivateRoute>} />
              <Route path="/admin/linkedin" element={<PrivateRoute><LinkedInAdmin /></PrivateRoute>} />
              <Route path="/admin/onboarding" element={<PrivateRoute><AdminOnboarding /></PrivateRoute>} />
              <Route path="/admin/ai-tools" element={<PrivateRoute><AdminAITools /></PrivateRoute>} />
              <Route path="/admin/ce-audit" element={<PrivateRoute><AdminCEAudit /></PrivateRoute>} />
              <Route path="/admin/certificates" element={<PrivateRoute><AdminCertificates /></PrivateRoute>} />
              <Route path="/admin/settings" element={<PrivateRoute><AdminSettings /></PrivateRoute>} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/billing" element={<PrivateRoute><BillingSettings /></PrivateRoute>} />
              <Route path="/team" element={<PrivateRoute><TeamDashboard /></PrivateRoute>} />
              <Route path="/team/session/new" element={<PrivateRoute><FirmSession /></PrivateRoute>} />
              <Route path="/team/members/:memberId" element={<PrivateRoute><TeamMemberManage /></PrivateRoute>} />
              <Route path="/team/help" element={<PrivateRoute><TeamHelpGuide /></PrivateRoute>} />
              <Route path="/team/report" element={<PrivateRoute><TeamComplianceReport /></PrivateRoute>} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/contact" element={<Contact />} />
              {/* Public Pages */}
              <Route path="/unsubscribe/:token" element={<UnsubscribePage />} />
              <Route path="/unsubscribe" element={<EmailPreferencesUnsubscribe />} />
              <Route path="/invite/:token" element={<InviteAccept />} />
              {/* State License Renewal Landing Pages */}
              <Route path="/ny-license-renewal" element={<NYLicenseRenewal />} />
              <Route path="/ct-license-renewal" element={<CTLicenseRenewal />} />
              <Route path="/nj-license-renewal" element={<NJLicenseRenewal />} />
              <Route path="/ca-license-renewal" element={<CALicenseRenewal />} />
              <Route path="/wa-license-renewal" element={<WALicenseRenewal />} />
              <Route path="/il-license-renewal" element={<ILLicenseRenewal />} />
              <Route path="/ga-license-renewal" element={<GALicenseRenewal />} />
              <Route path="/fl-license-renewal" element={<FLLicenseRenewal />} />
              <Route path="/ma-license-renewal" element={<MALicenseRenewal />} />
              <Route path="/pa-license-renewal" element={<PALicenseRenewal />} />
              <Route path="/tx-license-renewal" element={<TXLicenseRenewal />} />
              <Route path="/in-license-renewal" element={<INLicenseRenewal />} />
              <Route path="/mo-license-renewal" element={<MOLicenseRenewal />} />
              <Route path="/wi-license-renewal" element={<WILicenseRenewal />} />
              <Route path="/sc-license-renewal" element={<SCLicenseRenewal />} />
              <Route path="/ky-license-renewal" element={<KYLicenseRenewal />} />
              <Route path="/al-license-renewal" element={<ALLicenseRenewal />} />
              <Route path="/ut-license-renewal" element={<UTLicenseRenewal />} />
              <Route path="/nv-license-renewal" element={<NVLicenseRenewal />} />
              <Route path="/ok-license-renewal" element={<OKLicenseRenewal />} />
              <Route path="/ar-license-renewal" element={<ARLicenseRenewal />} />
              <Route path="/ak-license-renewal" element={<AKLicenseRenewal />} />
              <Route path="/az-license-renewal" element={<AZLicenseRenewal />} />
              <Route path="/co-license-renewal" element={<COLicenseRenewal />} />
              <Route path="/dc-license-renewal" element={<DCLicenseRenewal />} />
              <Route path="/de-license-renewal" element={<DELicenseRenewal />} />
              <Route path="/hi-license-renewal" element={<HILicenseRenewal />} />
              <Route path="/ia-license-renewal" element={<IALicenseRenewal />} />
              <Route path="/id-license-renewal" element={<IDLicenseRenewal />} />
              <Route path="/ks-license-renewal" element={<KSLicenseRenewal />} />
              <Route path="/la-license-renewal" element={<LALicenseRenewal />} />
              <Route path="/md-license-renewal" element={<MDLicenseRenewal />} />
              <Route path="/me-license-renewal" element={<MELicenseRenewal />} />
              <Route path="/mi-license-renewal" element={<MILicenseRenewal />} />
              <Route path="/mn-license-renewal" element={<MNLicenseRenewal />} />
              <Route path="/ms-license-renewal" element={<MSLicenseRenewal />} />
              <Route path="/mt-license-renewal" element={<MTLicenseRenewal />} />
              <Route path="/nc-license-renewal" element={<NCLicenseRenewal />} />
              <Route path="/nd-license-renewal" element={<NDLicenseRenewal />} />
              <Route path="/ne-license-renewal" element={<NELicenseRenewal />} />
              <Route path="/nh-license-renewal" element={<NHLicenseRenewal />} />
              <Route path="/nm-license-renewal" element={<NMLicenseRenewal />} />
              <Route path="/oh-license-renewal" element={<OHLicenseRenewal />} />
              <Route path="/or-license-renewal" element={<ORLicenseRenewal />} />
              <Route path="/ri-license-renewal" element={<RILicenseRenewal />} />
              <Route path="/sd-license-renewal" element={<SDLicenseRenewal />} />
              <Route path="/tn-license-renewal" element={<TNLicenseRenewal />} />
              <Route path="/va-license-renewal" element={<VALicenseRenewal />} />
              <Route path="/vt-license-renewal" element={<VTLicenseRenewal />} />
              <Route path="/wv-license-renewal" element={<WVLicenseRenewal />} />
              <Route path="/wy-license-renewal" element={<WYLicenseRenewal />} />
              {/* AI Generated Pages */}
              <Route path="/landing-modern" element={<LandingModern />} />
              <Route path="/landing-test10" element={<LandingTest10 />} />
              <Route path="/landing-minimalist" element={<LandingMinimalist />} />
              <Route path="/landing-original" element={<LandingOriginal />} />
              <Route path="/landing-tailwind" element={<LandingTailwind />} />
              {/* 404 catch-all — must be last */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </React.Suspense>
        </div>
      </div>
      <Footer />
    </div>
  );
}

function App() {
  const { user, logout, loading } = useAuth();
  if (loading) return <div>Loading...</div>;
  return (
    <Router>
      <AppInner user={user} logout={logout} />
    </Router>
  );
}

export default App;
